import { defineStore } from "pinia";
import type GatheringPublic from "~/pages/gathering/gathering-public.dto";

export const useGatheringListStore = defineStore("gatheringList", {
  state: () => ({
    list: [] as GatheringPublic[],
    fetchedAll: false,
    offset: 0,
  }),
  actions: {
    add(list: GatheringPublic[]) {
      const idSet = new Set(this.list.map((g) => g.id));
      list = list
        .filter((g) => !idSet.has(g.id))
        .filter((g) => g.memberInfo.count > 0);
      this.list = [...this.list, ...list];
    },
    clear() {
      this.list = [];
      this.fetchedAll = false;
      this.offset = 0;
    },
    setFetchedAll(fetchedAll: boolean) {
      this.fetchedAll = fetchedAll;
    },
    setOffset(offset: number) {
      this.offset = offset;
    },
  },
  getters: {
    getList: (state) => [...state.list],
  },
});
